/* import __COLOCATED_TEMPLATE__ from './article-content.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { BlocksDocument } from '@intercom/composer-ember';
import type { BlockList } from '@intercom/interblocks.ts';
import ArticlesComposerConfig from 'embercom/lib/articles/composer-config';
import type AppService from 'embercom/services/app-service';

interface ChangeStats {
  additions?: number;
  deletions?: number;
}

interface Args {
  title: string;
  originalContent: Array<Record<string, unknown>>;
  proposedContent: Array<Record<string, unknown>>;
  changeStats: ChangeStats;
}

interface Signature {
  Args: Args;
}

export default class ArticleContent extends Component<Signature> {
  @service declare appService: AppService;
  @service intercomEventService: $TSFixMe;

  get app() {
    return this.appService.app;
  }

  get proposedBlocksDocument() {
    return new BlocksDocument((this.args.proposedContent || []) as unknown as BlockList);
  }

  get originalBlocksDocument() {
    return new BlocksDocument((this.args.originalContent || []) as unknown as BlockList);
  }

  get proposedContentBlocks(): BlockList {
    return (this.args.proposedContent || []) as unknown as BlockList;
  }

  get prosemirrorComposerConfig() {
    let eventService = this.intercomEventService;
    let analytics = {
      trackAnalyticsEvent: (eventName: string, attrs: Record<string, unknown>) => {
        eventService.trackAnalyticsEvent({
          action: eventName,
          object: 'proposal',
          place: 'composer',
          ...attrs,
        });
      },
    };

    let config = new ArticlesComposerConfig(this.app, 'ltr', analytics, () => {});

    config.isInteractivityDisabled = true;
    config.autoFocus = false;
    return config;
  }

  get hasChanges(): boolean {
    return (
      (this.args.changeStats?.additions ?? 0) > 0 || (this.args.changeStats?.deletions ?? 0) > 0
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InternalAgent::Content::Proposals::ArticleContent': typeof ArticleContent;
    'internal-agent/content/proposals/article-content': typeof ArticleContent;
  }
}
